import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { VisuallyHidden } from '@change-corgi/design-system-legacy/a11y';
import { iconVictory } from '@change-corgi/design-system-legacy/icons';

import { usePetitionDetails } from '../../hooks/petitionDetails';
import { ShareContainer } from '../share';
import { SignatureStatsVictoryContainer } from '../stats/signatureStats';

import { SidePetitionStatus } from './components/SidePetitionStatus';

export function SideVictoryContainer(): JSX.Element {
	const { isVerifiedVictory } = usePetitionDetails();

	return (
		<>
			<SidePetitionStatus icon={iconVictory} iconColor="primary-changeRed">
				{isVerifiedVictory ? (
					<Translate value="fe.pages.petition_show.status.confirmed_victory" />
				) : (
					<Translate value="fe.pages.petition_show.status.victory" />
				)}
			</SidePetitionStatus>
			<SignatureStatsVictoryContainer textAlign="left" />
			<VisuallyHidden as="h2">
				<Translate value="fe.components.petition_share.action" />
			</VisuallyHidden>
			<ShareContainer forMobileView={false} />
		</>
	);
}
